// extracted by mini-css-extract-plugin
export var blackCard = "DescriptionCard-module--blackCard--5JFEJ";
export var heading = "DescriptionCard-module--heading--nm+FG";